module.exports = new __parcel__URL__("gra2pes-ghg-monthgrid-v1.thumbnails.total.50f4dcb9.png").toString();